
let LEVELS = {}

const newLevel = () => {
    return {
        angle:{},
        minDistance:false,
    }
}

const initLevels = () => {
    for (let i = 1; i <= 18;i++){
        let level = `LEVEL_${i}`;
        LEVELS[level] = newLevel();
    }
}
initLevels()

LEVELS.LEVEL_1.angle = {
    '0...75': 750,
    '75...285': 500,
    '285...360': 750,
}
LEVELS.LEVEL_1.minDistance = 900

LEVELS.LEVEL_2.angle = {
    '0...75': 850,
    '75...285': 600,
    '285...360': 850,
}
LEVELS.LEVEL_2.minDistance = 1600

LEVELS.LEVEL_3.angle = {
    '0...75': 500,
    '75...285': 300,
    '285...360': 500,
}
LEVELS.LEVEL_3.minDistance = 1000

LEVELS.LEVEL_4.angle = {
    '0...75': 190,
    '75...285': 130,
    '285...360': 190,
}
LEVELS.LEVEL_4.minDistance = 200

LEVELS.LEVEL_5.angle =  {
    '0...75': 100,
    '75...285': 75,
    '285...360': 100,
}
LEVELS.LEVEL_5.minDistance = 200

LEVELS.LEVEL_6.angle =  {
    '0...75': 45,
    '75...285': 30,
    '285...360': 45,
}
LEVELS.LEVEL_6.minDistance = 100


LEVELS.LEVEL_7.angle = {
    '0...75': 30,
    '75...285': 20,
    '285...360': 30,
}
LEVELS.LEVEL_7.minDistance = 80

LEVELS.LEVEL_8.angle =  {
    '0...75': 15,
    '75...285': 10,
    '285...360': 15,
}
LEVELS.LEVEL_8.minDistance = 40


LEVELS.LEVEL_9.angle =  {
    '0...75': 9,
    '75...285': 6,
    '285...360': 9,
}
LEVELS.LEVEL_9.minDistance = 30

LEVELS.LEVEL_10.angle =  {
    '0...75': 4.2,
    '75...285': 3,
    '285...360': 4.2,
}
LEVELS.LEVEL_10.minDistance = 15

LEVELS.LEVEL_11.angle =  {
    '0...75': 1.80,
    '75...285': 1.1,
    '285...360': 1.80,
}
LEVELS.LEVEL_11.minDistance = 3


LEVELS.LEVEL_12.angle =  {
    '0...75': 0.8,
    '75...285': 0.6,
    '285...360': 0.8,
}
LEVELS.LEVEL_12.minDistance = 2


LEVELS.LEVEL_13.angle =  {
    '0...75': 0.45,
    '75...285': 0.35,
    '285...360': 0.45,
}
LEVELS.LEVEL_13.minDistance = 1.5

LEVELS.LEVEL_14.angle =  {
    '0...75': 0.25,
    '75...285': 0.18,
    '285...360': 0.25,
}
LEVELS.LEVEL_14.minDistance = 1

LEVELS.LEVEL_15.angle =  {
    '0...75': 0.10,
    '75...285': 0.075,
    '285...360': 0.10,
}
LEVELS.LEVEL_15.minDistance = 0.75

LEVELS.LEVEL_16.angle =  {
    '0...75': 0.060,
    '75...285': 0.04,
    '285...360': 0.060,
}
LEVELS.LEVEL_16.minDistance = 0.4

LEVELS.LEVEL_17.angle =  {
    '0...75': 0.030,
    '75...285': 0.02,
    '285...360': 0.030,
}
LEVELS.LEVEL_17.minDistance = 0.3

// LEVELS.LEVEL_18.angle =  {
//     '75...285': 0.020,
// }


export default LEVELS